import { Injectable } from '@angular/core';
import { _ } from '@ngx-translate/core';
import { BaseEntity } from 'app/core/classes/base-entity';
import { I18nService } from 'app/services/i18n.service';
import { ONE_DAY, ONE_HOUR, ONE_MINUTE, ONE_SECOND } from 'app/utils/services/date.service';

export interface FluidSecondsToDurationOptionsInterface {
  hideEmpty?: boolean;
  hideSeconds?: boolean;
  showDays?: boolean;
  unitsArr?: string[];
}

export class FluidSecondsToDurationOptions implements FluidSecondsToDurationOptionsInterface {
  hideEmpty: boolean = false;
  hideSeconds: boolean = false;
  showDays: boolean = false;
  unitsArr: string[] = [
    _('d@@Carattere abbreviato di giorni'),
    _('h@@Carattere abbreviato di ore'),
    _('m@@Carattere abbreviato di minuti'),
    _('s@@Carattere abbreviato di secondi'),
  ];

  constructor(data?: FluidSecondsToDurationOptionsInterface) {
    BaseEntity.init(this, data);
  }
}

@Injectable({
  providedIn: 'root',
})
export class FluidDurationService {
  constructor(private readonly _i18nService: I18nService) {}

  secondsToHuman(value: number, opts?: FluidSecondsToDurationOptionsInterface) {
    opts = new FluidSecondsToDurationOptions(opts);

    let unitArr = [...opts.unitsArr].map((v) => this._i18nService.translate(v));

    let v = Math.abs((Math.round(value) || 0) * 1000);
    const timeArr: number[] = [];

    // build full array [days, hours, minutes, seconds]
    const d = Math.floor(v / ONE_DAY);
    timeArr.push(d);
    v -= d * ONE_DAY;

    const h = Math.floor(v / ONE_HOUR);
    timeArr.push(h);
    v -= h * ONE_HOUR;

    const m = Math.floor(v / ONE_MINUTE);
    timeArr.push(m);
    v -= m * ONE_MINUTE;

    const s = Math.floor(v / ONE_SECOND);
    timeArr.push(s);

    // SHOW 01d if 24h
    const somethingElseExists = true; // s > 0 || m > 0 || h > 0;

    // apply user options
    if (!opts.showDays && somethingElseExists) {
      timeArr.shift();
      unitArr.shift();
    }

    if (opts.hideSeconds) {
      timeArr.pop();
      unitArr.pop();
    }

    return this._formatTime(timeArr, unitArr, opts.hideEmpty);
  }

  private _formatTime(values: number[], unitArr: string[], hideEmpty = true): string {
    let v = values;
    let l = unitArr;

    if (hideEmpty) {
      const first = values.findIndex((x) => x !== 0);
      const last = values.length - 1 - [...values].reverse().findIndex((x) => x !== 0);
      if (first !== -1) {
        v = values.slice(first, last + 1);
        l = unitArr.slice(first, last + 1);
      } else {
        v = [0];
        l = [unitArr.at(-1)!];
      }
    }

    return v.map((val, i) => `${String(val).padStart(2, '0')}${l[i]}`).join(' ');
  }
}
